import Gap from '~/components/Gap';
import Text from '~/components/Text';
import { IListInvoice } from '~/types/invoice';
import { getInvoiceStatus } from './helpers';
import { useIsDesktop } from '~/hooks/useIsDesktop';

interface IInvoiceDueStatusProps {
  invoiceData: IListInvoice;
}

const InvoiceDueStatus = ({ invoiceData }: IInvoiceDueStatusProps) => {
  const isDesktop = useIsDesktop();

  if (invoiceData.archived === true) {
    return null;
  }
  const dueStatus = getInvoiceStatus(invoiceData);
  return (
    <div className="align-center">
      {dueStatus.icon && (
        <>
          <dueStatus.icon size={isDesktop ? 12 : 8} color={`var(--${dueStatus.color})`} />
          <Gap r={3} />
        </>
      )}
      <Text size={isDesktop ? 'xs' : 'xxs'} variant={dueStatus.color}>
        {dueStatus.label}
      </Text>
    </div>
  );
};

export default InvoiceDueStatus;
